import { render, staticRenderFns } from "./InventorySelect.vue?vue&type=template&id=dca730a6&scoped=true"
import script from "./InventorySelect.vue?vue&type=script&lang=js"
export * from "./InventorySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca730a6",
  null
  
)

export default component.exports